export const NavigateConst = {
  dashboard: '/dashboard',
  profile: '/profile',
  memberProfile: '/home/member-profile',
  enrollBenefits: '/home/enroll-benefits',
  medicalClaimsURL: '/home/medical-claims',
  registration: '/account/activation',
  homeContactUs: '/home/contact-us',
  wellnessProgram: '/home/wellness-programs',
  formsAndDocuments: '/home/forms-and-documents',
  authorization: '/home/authorizations',
  memberIDCard: '/home/member-id-card',
  physicalTherapy: '/home/physical-therapy',
  pharmacyTools: '/home/pharmacy-tools',
  yourPlan: "/home/your-plan",
  claimsSummary: '/home/claims-summary',
  superEOBClaims: '/home/eob-claims',
  superRelatedClaims: '/home/related-claims',
  forgotUsername: '/login/forgot-username',
  resetPassword: '/reset-password',
  benefits: '/home/benefits',
  contactUs: "contact-us",
  formsAndDocuments: "forms-and-documents",
  signIn: "/sign-in",
  paySentaraBillURL: '/home/pay-your-sentara-bill',
  launchDarklyKey: '/contexts/',
  dropdownValue: '/home/view-tax-summary',
  footerContactUs: '/home/contact-us',
  yourPlanId: '?id=1',
  myPlan: '/home/your-plan?id=',
  vlocityEnrollBenefits: 'Vlocity/EnrollBenefits',
  medicalClaimsURL: '/home/medical-claims',
  proxyExpiredForm: '/proxy-expired-form',
  csrProxyForm: '/csr-proxy-form',
  csrProxySuccess: '/csr-proxy-success',
  registrationProxy: '/account/activationChildOnlyPlan',
  findADoctor: '/home/find-a-doctor',
  changePCP: '/home/change-primary-care-provider',
  drRegistration: '/account/activation/dr-registration',
  childOnlyPlanDesignatedRep: '/account/activation/dr-child-only-plan',
  drAuthorizationChooser: '/dr-authorization',
  guestSharedAccounts: '/home/accounts-shared-with-me',
  guestDefault: '/home/guest',
};
